<template>
    <v-container id="forgotPassword">
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="6" xl="4" class="py-0 mb-8">
        <v-row align="end">
          <!-- Logo -->
          <v-col cols="12">
            <v-img src="/logo.png" aspect-ratio="5" contain></v-img>
          </v-col>
          <!-- Logo text-->
          <v-col cols="12">
            <v-img src="/LogoText.png" aspect-ratio="5" contain></v-img>
          </v-col>

          <v-row justify="center">
            <v-col cols="10" v-show="showForm">
              <a 
              class="backLink"
              href="/login"
              >{{ labels.backToLoginPage }}</a>

              <ApiForm
                ref="passwordFrom"
                :formElements="elements"
                :extractErrorsFn="errors"
                :successFn="success"
                :submit="submit"
                :useCancel="false"
                endpoint="account/recoverPassword"
                method="put"
                :formObject="formObject"
            />
            <p class="successMessage">
              {{ successMessage }}
            </p>
            </v-col>
            <v-col cols="12">
              <p class="errorMessage">
                {{ errorMessage }}
              </p>
            </v-col>
          </v-row>
          
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'
import httpClient from '../../api/httpClient'

export default {
  data() {
    return {
      elements: [
        {
          key: 'NewPassword',
          component: 'v-text-field',
          rules: 'required',
          label: '$newPassword',
          type: 'password',
          props: {
            solo: true,
            dense: true,
            hideDetails: 'auto'
          }
        },
        {
          key: 'ConfirmPassword',
          component: 'v-text-field',
          rules: 'required|confirmed:NewPassword',
          label: '$confirmPassword',
          type: 'password',
          props: {
            solo: true,
            dense: true,
            hideDetails: 'auto'
          }
        },
        {
          key: 'Token',
          component: 'v-text-field',
          hidden: true,
          sendOnHidden: true
        }
      ],
      submit: { text: '$send', color: 'white' },
      labels: {
        backToLoginPage: translate('Back to log in page', 'pages.recoverPassword')
      },
      showForm: false,
      errorMessage: '',
      successMessage: '',
      token: '',
      formObject: {}
    }
  },
  computed: {},
  mounted() {
    var that = this
    this.token = this.$route.query.token
    this.formObject = {
      NewPassword: '',
      ConfirmPassword: '',
      Token: that.token
    }
    this.tokenVerification()
  },
  methods: {
    errors(data) {
      return data.errors.map(el => {
        return {
          propertyName: el.PropertyName,
          error: el.Error
        }
      })
    },
    success() {
      this.$refs.passwordFrom.resetForm()
      this.successMessage = translate(
        'Your password has been changed successfully.',
        'pages.recoverPassword'
      )
    },
    tokenVerification() {
      var endpoint = 'account/tokenVerification?token=' + this.token

      httpClient
        .get(endpoint)
        .then(response => {
          this.showForm = true
        })
        .catch(error => {
          this.showForm = false
          if (error.response.status == 422) {
            this.errorMessage = translate(
              'The token does not exist or has expired',
              'pages.recoverPassword'
            )
          } else {
            this.errorMessage = translate(
              'Server error, call your administrator',
              'pages.recoverPassword'
            )
          }
        })
    }
  }
}
</script>

<style scoped>
.backLink {
  color: white !important;
  text-decoration: none !important;
}
.errorMessage {
  font-size: 18px !important;
  color: red !important;
}
.successMessage {
  color: white !important;
  font-size: 18px !important;
}
</style>
